import { render } from "./LoadElements.vue?vue&type=template&id=58bfee2b&scoped=true"
import script from "./LoadElements.vue?vue&type=script&lang=ts"
export * from "./LoadElements.vue?vue&type=script&lang=ts"

import "./LoadElements.vue?vue&type=style&index=0&id=58bfee2b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-58bfee2b"

export default script